import { render } from "./ManualAttendanceApply.vue?vue&type=template&id=19898c22&scoped=true&ts=true"
import script from "./ManualAttendanceApply.vue?vue&type=script&lang=ts"
export * from "./ManualAttendanceApply.vue?vue&type=script&lang=ts"

import "./ManualAttendanceApply.vue?vue&type=style&index=0&id=19898c22&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19898c22"]])

export default __exports__